const ITEMS = [
  { src: "/tech-stack/react.svg", title: "React" },
  { src: "/tech-stack/expo.webp", title: "React Native / Expo" },
  { src: "/tech-stack/typescript.svg", title: "TypeScript" },
  { src: "/tech-stack/next-js.svg", title: "Next.js" },
  { src: "/tech-stack/laravel.svg", title: "Laravel / PHP" },
  { src: "/tech-stack/tailwind.svg", title: "Tailwind" },
  { src: "/tech-stack/scss.svg", title: "SCSS" },
  { src: "/tech-stack/node.svg", title: "Node" },
  { src: "/tech-stack/git-icon.svg", title: "Git" },
];

export default function TechStack() {
  return (
    <div className="techstack">
      <span className="techstack-label">TECH&nbsp;STACK</span>
      <ul className="techstack-list">
        {ITEMS.map((it, i) => (
          <li key={i} className="tech-chip" title={it.title}>
            <span className="tech-logo">
              <img src={it.src} alt={it.title} />
            </span>
            <span className="tech-name">{it.title}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}
